<div class="kLiveDashboardContainer">
  <div class="kHeader">
    <i class="kIconclose_small kClose" (click)="_close()"></i>
    <span class="kTitle">{{ 'applications.content.liveDashboard.title' | translate }}</span>
  </div>
  <div class="kLiveDashboardHost">
    <kLiveDashboardHost [entryId]="entryId"></kLiveDashboardHost>
  </div>
</div>
